//Se importa el storage del archivo config de firebase
import axios from "axios";
import { clearDoc } from "./doctor";
import { successAlert, errorAlert } from "./ui";
//Libreria para el uso de alertas
import Swal from "sweetalert2";

export const uploadDocumentPatientToStorage = async (
    formik,
    date_created,
    date_ms,
    file,
    fileToEmail,
    docs,
    setDocs,
    methodScreenLoading,
    methodMsgLoading,
    typeDocument,
    sendReportToEmail,
    hideModalLicense,
    msgAlert
) => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const urlServer = reduxStore.urlServer;
    const db = reduxStore.db;
    const storage = reduxStore.storage;

    const country = formik.values.scheduleCountry.replaceAll(" ", "").toLowerCase();
    let ref = storage.child(
        `documentos/${country}/${formik.values.patientDNI}/${date_created}/${date_ms}_${file.name}`
    );

    ref.put(file).then(function (snapshot) {
        snapshot.ref.getDownloadURL().then(function (downloadURL) {

            if (!sendReportToEmail) {
                if (methodScreenLoading) methodScreenLoading(false);
                if (methodMsgLoading) methodMsgLoading("");
            }

            setDocs([
                ...docs,
                {
                    path: `documentos/${country}/${formik.values.patientDNI}/${date_created}/${date_ms}_${file.name}`,
                    name: file.name,
                    urlFile: downloadURL,
                    sendToPatient: true,
                    dateUpload: new Date(),
                    type: typeDocument,
                },
            ]);

            formik.values.pathFiles = [
                ...docs,
                {
                    path: `documentos/${country}/${formik.values.patientDNI}/${date_created}/${date_ms}_${file.name}`,
                    name: file.name,
                    urlFile: downloadURL,
                    sendToPatient: true,
                    dateUpload: new Date(),
                    type: typeDocument,
                },
            ];

            let updloadFile = document.getElementById("ipUploadFile");

            if (updloadFile) {
                updloadFile.value = null;
            }

            if (sendReportToEmail) {

                let subject = "", nameDocument = "";

                switch (typeDocument) {
                    case "document":
                        subject = "Documento Generado";
                        nameDocument = "Documento Generado";
                        break;
                    case "report-medicines":
                        subject = "Receta Medicamento";
                        nameDocument = "Receta Medicamento";
                        break;
                    case "license":
                        subject = "Informe Licencia Médica";
                        nameDocument = "Informe Licencia Médica";
                        break;
                    default:
                        subject = "Documento Generado";
                        nameDocument = "Documento Generado";
                        break;
                }

                const dataToSendEmail = {
                    email: formik.values.patientEmail,
                    subject,
                    nameDocument,
                    template: "sendFileToPatient",
                    patientName: `${formik.values.patientNameComplete} ${formik.values.patientLastNameComplete}`,
                    files: [fileToEmail]
                }

                axios
                    .post(`${urlServer}/mails/sendAttachment`, dataToSendEmail)
                    .then((responseDocument) => {
                        if (responseDocument.status === 200) {
                            const idDoc = formik.values.timestamp;
                            const updateFiles = db.collection("attention").doc(country).collection(formik.values.patientDNI).doc(idDoc.toString());

                            if (typeDocument === "license") {
                                updateFiles.update({
                                    "attention.recoverability": formik.values.recoverability,
                                    "attention.dateReturn": formik.values.dateReturn ? formik.values.dateReturn : ''
                                })
                            }

                            updateFiles.update({
                                "pathFiles": formik.values.pathFiles,
                            }).then(() => {
                                if (methodScreenLoading) methodScreenLoading(false);
                                if (hideModalLicense) hideModalLicense();
                                if (msgAlert) successAlert(msgAlert);
                            }).catch((error) => {
                                // The document probably doesn't exist.
                                if (methodScreenLoading) methodScreenLoading(false);
                                errorAlert("No se pudo actualizar el informe en documentos de la Ficha, notificarlo al Área de TI");
                                console.error("Error updating document: ", error);
                            });

                        } else {
                            if (methodScreenLoading) methodScreenLoading(false);
                            if (hideModalLicense) hideModalLicense();
                            errorAlert("No se pudo Generar el Informe con Éxito, notificarlo al Área de TI");
                        }
                    }).catch((error) => {
                        console.log(error)
                        if (methodScreenLoading) methodScreenLoading(false);
                        if (hideModalLicense) hideModalLicense();
                        errorAlert("No se pudo Generar el Informe con Éxito, notificarlo al Área de TI");
                    });

            } else {
                if (hideModalLicense) hideModalLicense();
                if (msgAlert) successAlert(msgAlert);
            }
        });
    });
}

export const urlBase64ToFile = async (url, filename, mimeType) => {
    const res = await fetch(url);
    const buf = await res.arrayBuffer();
    return new File([buf], filename, { type: mimeType });
}

export const sendAttachmentFromURLToEmail = async (dataOfUser, documentToSend, setLoading) => {
    const { getReduxStore } = await import('../helpers/reduxInstance');
    const reduxStore = await getReduxStore();
    const urlServer = reduxStore.urlServer;

    const dataAttachment = {
        email: dataOfUser.patientEmail,
        subject: "Documento Solicitado | Medival",
        template: "sendFileToPatient",
        nameDocument: "DOCUMENTO",
        patientName: dataOfUser.patientNameComplete,
        filename: documentToSend.name,
        path: documentToSend.urlFile
    }

    axios
        .post(`${urlServer}/mails/sendAttachmentFromURL`, dataAttachment)
        .then((responseDocument) => {
            console.log(responseDocument)
            successAlert("Documento Generado con Éxito");
            setLoading(false);
        })
        .catch((error) => {
            errorAlert("No se pudo Generar el Informe con Éxito, notificarlo al Área de TI");
            console.log(error)
        });

}

export const deleteDocument = (docs, setDocs, formik, index) => {
    return async () => {
        const { getReduxStore } = await import('../helpers/reduxInstance');
        const reduxStore = await getReduxStore();
        const storage = reduxStore.storage;

        const fileToDelete = docs.filter((file, ind) => ind === index);
        const filesFilter = docs.filter((file, ind) => ind !== index);

        var framePdf = document.getElementById("framePdf");
        framePdf.src = "";

        formik.values.files = formik.values.files.filter(
            (file, ind) => ind !== index
        );

        let ref = storage.child(fileToDelete[0].path);
        ref
            .delete()
            .then(function () {
                // File deleted successfully
                console.log("Se eliminó el archivo");
            })
            .catch(function (error) {
                console.log("Hubo un error");
            });

        setDocs(filesFilter);
        formik.values.pathFiles = filesFilter;

        Swal.fire("Borrado !", "El archivo ha sido Eliminado.", "success");
    }
};

export const deleteAllDocuments = (docs, setDocs, formik, setLoading, setMsg, dispatch) => {
    return async () => {
        const { getReduxStore } = await import('../helpers/reduxInstance');
        const reduxStore = await getReduxStore();
        const storage = reduxStore.storage;

        setLoading(true);
        setMsg("Borrando Archivos");
        var framePdf = document.getElementById("framePdf");
        framePdf.src = "";

        docs.forEach((file) => {
            let ref = storage.child(file.path);
            ref.delete()
                .then(function () {
                    // File deleted successfully
                    console.log("Se eliminó el archivo");
                })
                .catch(function (error) {
                    console.log("Hubo un error");
                });
        });

        formik.values.files = [];
        formik.values.pathFiles = "";

        setLoading(false);
        setMsg("");
        setDocs([]);
        dispatch(clearDoc());
        Swal.fire("Borrados !", "Archivos Eliminados.", "success");
    }
}